import AsyncStorage from "@react-native-async-storage/async-storage";

// Recorded handover videos whose upload failed, kept so the partner can retry
// the upload without re-recording. Maps "flow:crate:date" -> {uri, duration,
// classification, savedAt}. Only the file PATH is stored — the video itself
// stays where the camera wrote it (app cache), which Android may purge, so
// consumers must handle a missing file.
const STORE_KEY = "handover_saved_videos";

// Past this age the delivery day is over and the cached file is likely gone.
const MAX_AGE_MS = 48 * 60 * 60 * 1000;

export const savedVideoKey = (crate) =>
  `${crate.flow_type}:${crate.crate_id}:${crate.delivery_date}`;

const readStore = async () => {
  try {
    return JSON.parse(await AsyncStorage.getItem(STORE_KEY)) || {};
  } catch {
    return {};
  }
};

const writeStore = (store) =>
  AsyncStorage.setItem(STORE_KEY, JSON.stringify(store));

export const getSavedVideos = async () => {
  const store = await readStore();
  const now = Date.now();
  const fresh = {};
  Object.entries(store).forEach(([key, entry]) => {
    if (entry && now - (entry.savedAt || 0) < MAX_AGE_MS) fresh[key] = entry;
  });
  if (Object.keys(fresh).length !== Object.keys(store).length) {
    await writeStore(fresh);
  }
  return fresh;
};

export const saveVideo = async (key, entry) => {
  const store = await readStore();
  store[key] = { ...entry, savedAt: Date.now() };
  await writeStore(store);
};

export const removeSavedVideo = async (key) => {
  const store = await readStore();
  if (key in store) {
    delete store[key];
    await writeStore(store);
  }
};
